import FormJaivana from 'dashboard_jaivana_v1';

/**
 *
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */

class CustomReformulacionAjustes extends FormJaivana.form {

    constructor(props) {
        super(props);
        this.initForm                   = this.initForm.bind(this);
        this.successTablaItemFichas     = this.successTablaItemFichas.bind(this);
        this.setButtonDelete            = this.setButtonDelete.bind(this);
        this.deleteEspecification       = this.deleteEspecification.bind(this);
        this.uploadTable                = this.uploadTable.bind(this);
        this.confirmDeleteCustom        = this.confirmDeleteCustom.bind(this);
        this.tamanoDatos                = 0;
        this.successDelete              = this.successDelete.bind(this);
        this.grabarItem                 = this.grabarItem.bind(this);
        this.grabarTodo                 = this.grabarTodo.bind(this);
        this.successGrabarItem          = this.successGrabarItem.bind(this);
        this.formato                    = this.formato.bind(this);
        this.successDatosFicha          = this.successDatosFicha.bind(this);
        this.observacion                = '';
        this.etapa_id                   = 0;
        this.abastecimiento             = '';
        this.id_delete  = 0;
        this.productoAveriado           = this.productoAveriado.bind(this);
        this.confirmProductoAveriado    = this.confirmProductoAveriado.bind(this);

        this.traerBodegas               = this.traerBodegas.bind(this);
        this.successTraerBodega         = this.successTraerBodega.bind(this);
        this.valueChangeOperario        = this.valueChangeOperario.bind(this);
        this.limpiarCampos              = this.limpiarCampos.bind(this);
        this.verFormula                 = this.verFormula.bind(this);
        this.successVerFormula          = this.successVerFormula.bind(this);
        this.gridOptionsVerFormula      = Object.assign({}, this.gridOptions);
        this.successClose               = this.successClose.bind(this);
    }

    initForm() {
        console.log('CustomReformulacionAjustes @version: 1.01.0054 @author: Santiago_Hernandez; @updateBy Sebastian Rios Echverri');

        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successDatosFicha,
            error: this.error_,
            general: this.generalFormatPmv
        });

        this.generalFormatPmv = { tipo_servicio: 'prod-reformulacionajustes', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTablaItemFichas,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '443-servicio_reformula_ajustes_traer_datos_fichas'; // servicio_traer_datos_ficha_etapas nombre_accion: es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: bodys,
                success: this.successDatosFicha,
                error: this.error_,
                general: this.generalFormat
            });       
            
        let body = {
            value: this.props.data.id_ficha,
        }
        this.generalFormat.nombre_accion = '443-servicio_reformula_ajustes_traer_porid_prod_idficha'; // servicio_traer_datos_ficha_etapas nombre_accion: es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successTablaItemFichas,
                error: this.error_,
                general: this.generalFormat,
                showMessage :false
            }); */      
        this.getField('btnAgragarAjuste').setClick(this.grabarItem);
        this.getField('btnGrabarAjuste').setClick(this.grabarTodo);
        this.getField('btnProductoAveriado').setClick(this.productoAveriado);
        this.getField('nombre').setOnChange(this.traerBodegas);
        this.getField('btn_verformula').setClick(this.verFormula);
    }

    verFormula(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'verformula', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerFormula,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });
    }

    successVerFormula(data){
        if (data.estado_p === 200 && data.data.length >= 1) {
            this.getField('modal_verformula').handleClickOpen();
            this.getField('tb_verformula').toggle(true);
            this.gridOptionsVerFormula['rowData'] = data.model;
            let configCell = new Map();
            configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
            configCell.set('version',{headerName: 'Versión'});
            configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
            configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
            this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
        }else if (data.estado_p === 404){
            this.alertGeneral.toggle(true,'No hay datos',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }else{
            this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }
    }
    
    successDatosFicha(data){
        let datosFicha = [];
        if(data.estado_p === 200 && data.model !== undefined && data.model.length > 0){
            this.getField('listaAjustes').setVisible(true);
            datosFicha.push(data.data[0]);
            this.getField('listaAjustes').setItemsFichas(datosFicha);
        } else{
            this.getField('listaAjustes').setVisible(false);
        }
    }
    
    
    formato(props){
        return ("".formatoPrecio(props.data.cantidad));
    }

    successTablaItemFichas(data){
        if(data.estado_p === 200){
            this.tamanoDatos = data.model.length;
            this.gridOptions['rowData'] = [];
            this.getField('tablaAjustes').initData(this.gridOptions);
            let configCell = new Map();
            configCell.set(0,{cellRenderer:this.setButtonDelete ,field: 'accion' });
            configCell.set('cantidad',{cellRenderer:this.formato, cellStyle: { textAlign: "right" },field: 'cantidad' });
            this.gridOptions['rowData'] = data.model;
            this.getField('tablaAjustes').initData(this.gridOptions,configCell);
            this.limpiarCampos();
        }else{
            this.getField('tablaAjustes').toggle(false);
            this.limpiarCampos();
            this.tamanoDatos = 0;
        }
    }
    
    setButtonDelete(props){
        let id = props.data.id;

        let button = document.createElement("input"); 
        button.onclick = ()=>this.deleteEspecification(id);
        button.setAttribute("id",'button_delete_'+id);
        button.setAttribute("class","buttonStyle");//,"width:100%; height: 100%; background-color:#303f9f;color:#fff;border:1px solid #303f9f;padding-left:5px;padding-rigth:5px;padding-top:2px;padding-bottom:2px;border-radius:3px; cursor:pointer");
        button.setAttribute("type","button");
        button.setAttribute("value","Eliminar");
        return this.createElementJaivana(button);
    }

    deleteEspecification(id){
        this.id_delete = id;
        this.getField('confirmModalCustom').setTitleAndContent('Eliminar', 'Desea realizar esta operación?');
        this.getField('confirmModalCustom').setClickDialog(this.confirmDeleteCustom);
        this.getField('confirmModalCustom').toggle(true);
    }

    confirmDeleteCustom(){
        this.getField('confirmModalCustom').toggle(false);
        let datos = {
            datos:{
                id: this.id_delete, 
                actividad_id:this.props.data.actividad_id
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-reformulacionajustes', operacion: 'eliminar', operacion_tipo: 'eliminar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'DELETE',
            body: datos,
            success: this.successDelete,
            error: this.error_,
            general: this.generalFormatPmv
        });
       /*this.generalFormat.nombre_accion = '443-servicio_reformula_ajustes_eliminar_fichas'; // nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'DELETE',
                body: body,
                success: this.successDelete,
                error: this.error_,
                general: this.generalFormat
            });*/

    }

    successDelete(model){
        //console.log("entro al successDelete");
        if(model.estado_p === 200){
            this.getField('fieldAlert').toggle(true,"Acción Exitosa","success");
            this.uploadTable();
        }
    }

    uploadTable(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-reformulacionajustes', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTablaItemFichas,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '443-servicio_reformula_ajustes_traer_porid_prod_idficha'; // servicio_traer_datos_ficha_etapas nombre_accion: es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successTablaItemFichas,
                error: this.error_,
                general: this.generalFormat,
                showMessage :false
            });*/      
       //this.service.send(this.getConstant().searchFormat().format(this.props.data.id_ficha,"tablaAjustes",'servicio',this.formId), 'GET', undefined ,this.successTablaItemFichas,this.error_);
    }

    grabarTodo(){
        if(this.tamanoDatos > 0){
            let datos = {
                datos:{
                    produccion_fichas_id: this.props.data.id_ficha,
                    proceso_id: this.props.data.proceso_id,
                    actividad_configuracion_id: this.props.data.actividad_configuracion_id,
                    actividad_id: this.props.data.actividad_id
                }
            }

            this.getField('btnGrabarAjuste').setDisabled(true);

            this.generalFormatPmv = { tipo_servicio: 'prod-reformulacionajustes', operacion: 'grabar', operacion_tipo: 'crear' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'POST',
                body: datos,
                success: this.successClose,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '443-servicio_reformula_ajustes_grabar_fichas'; // servicio_traer_datos_ficha_etapas nombre_accion: es el nombre que tenga el servicio en la tabla servicios_formulario
            this.service.send( 
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: body,
                    success: this.successCloseEstage,
                    error: this.error_,
                    general: this.generalFormat
                }); */     
        }else{
            this.alertGeneral.toggle(true,'Debe agregar mínimo un producto',"error");
        }
    }

    successClose(data){
        this.getField('btnGrabarAjuste').setDisabled(false);
        this.getField('btnProductoAveriado').setDisabled(false);
        this.successCloseEstage(data);
    }

    grabarItem(){
        if(
            this.getField('articulo_id').valid() &
            this.getField('nombre').valid() &
            this.getField('cantidad').valid() &
            this.getField('codigo').valid() &
            this.getField('unidad_id').valid()
        ){
            let datos = {
                datos:{
                    produccion_fichas_id: this.props.data.id_ficha,
                    articulo_id: this.getField('articulo_id').getValue(),
                    cantidad: this.getField('cantidad').getValue(),
                    codigo_bodega: this.getField('codigo_bodega').getValue(),
                    actividad_id:this.props.data.actividad_id
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-reformulacionajustes', operacion: 'crear', operacion_tipo: 'crear' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'POST',
                body: datos,
                success: this.successGrabarItem,
                error: this.error_,
                general: this.generalFormatPmv
            });

            /*this.generalFormat.nombre_accion = '443-servicio_reformula_ajustes_crear_fichas_items'; // servicio_traer_datos_ficha_etapas nombre_accion: es el nombre que tenga el servicio en la tabla servicios_formulario
            this.service.send( 
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: body,
                    success: this.successGrabarItem,
                    error: this.error_,
                    general: this.generalFormat
                });*/   
        }
    }

    successGrabarItem(data){
        if(data.estado_p === 200){
            this.uploadTable();
        }
    }

    limpiarCampos(){
        this.getField('articulo_id').setValue('');
        this.getField('nombre').setValue('');
        this.getField('cantidad').setValue('');
        this.getField('codigo').setValue('');
        this.getField('unidad_id').setValue('');
        this.getField('nombre_unidad').setValue('');
        this.getField('bodega').setValue('');
    }

    productoAveriado(){
        //this.id_delete = id;
        this.getField('btnProductoAveriado').setDisabled(true);
        this.getField('confirmModalCustom').setTitleAndContent('Confirmar', 'Desea enviar como producto averiado?');
        this.getField('confirmModalCustom').setClickDialog(this.confirmProductoAveriado);
        this.getField('confirmModalCustom').toggle(true);
    }

    confirmProductoAveriado(){

        let datos = {
            datos:{
                produccion_fichas_id: this.props.data.id_ficha,
                proceso_id: this.props.data.proceso_id,
                actividad_configuracion_id: this.props.data.actividad_configuracion_id,
                actividad_id: this.props.data.actividad_id
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-reformulacionajustes', operacion: 'pesaje', operacion_tipo: 'crear' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.successClose,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '443-Servicio_reformula_ajustes_boton_producto_averiado'; // servicio_traer_datos_ficha_etapas nombre_accion: es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'POST',
                body: body,
                success: this.successCloseEstage,
                error: this.error_,
                general: this.generalFormat
            });*/ 

    }

    traerBodegas(){
        if(this.getField('articulo_id').getValue() !== undefined && this.getField('articulo_id').getValue() !== ''){
            //console.log("entro al traer bodegas",this.getField('articulo_id').getValue());
            let datos = {
                datos:{
                    value: this.getField('articulo_id').getValue(),
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-articulo', operacion: 'saldobodegas', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successTraerBodega,
                error: this.error_,
                general: this.generalFormatPmv
            });
            // produccion_articulo-saldobodegas
            /*this.generalFormat.nombre_accion = '443-servicio_producion_fichas_ref_ajustes_select_bodegas_art'; // servicio_traer_datos_ficha_etapas nombre_accion: es el nombre que tenga el servicio en la tabla servicios_formulario
            this.service.send( 
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: body,
                    success: this.successTraerBodega,
                    error: this.error_,
                    general: this.generalFormat
                });*/   
           //this.service.send(this.getConstant().formSave(), 'POST', data  ,this.successGrabarItem,this.error_);
            
        }else{
            this.getField('articulo_id').setOnChange(this.traerBodegas);
        }
 }
    
    successTraerBodega(data){
        //console.log("entro al succes de traer bodegas",data);
            let opciones = [{
                'text':'Ninguno',
                'value':'',
                'campos_cambian':{}
            }];
            if (data.estado_p === 200) {
                data.data.forEach(item => {
                    let dataOp = {}
                    dataOp['value'] = item.codigo_bodega;
                    dataOp['text'] = `${item.nombre_bodega} , saldo = ${item.saldo}`;
                    //dataOp['text'] = item.nombre_bodega + ", " + "saldo = " + item.saldo;
                    dataOp['campos_cambian'] = {codigo_bodegaCodME : item.codigo_bodega};
                    opciones.push(dataOp);
                })
                this.getField('bodega').setOptions(opciones);
            }else{
                this.getField('bodega').setOptions(opciones);
            }

        this.getField('bodega').setOnChange(this.valueChangeOperario);
    }

    valueChangeOperario(){
        let codigo_bodega = this.getField('bodega').getValue();
        this.getField('codigo_bodega').setValue(codigo_bodega);

    }
}

FormJaivana.addController("prod-reformulacionajustes",CustomReformulacionAjustes);

export default CustomReformulacionAjustes;